import { render, staticRenderFns } from "./GroupPermisionTitle.vue?vue&type=template&id=0b6b61c1"
import script from "./GroupPermisionTitle.vue?vue&type=script&lang=js"
export * from "./GroupPermisionTitle.vue?vue&type=script&lang=js"
import style0 from "./GroupPermisionTitle.vue?vue&type=style&index=0&id=0b6b61c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports